import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { LocationContext } from "../../CustomHelper/Helper";
import Navigation from "../../components/Layouts/Header/Navigation";
import MyVerticallyCenteredModal from "../../components/RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import { serverInfo } from "../../App";

const Shipping = () => {
  let { slug } = useParams();

  const [modalShow, setModalShow] = React.useState(false);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [deliverychargelist, setDeliveryChargeList] = useState([]);
  const [deliverychargeid, setDeliveryChargeId] = useState('');
  const [deliverycharge, setDeliveryCharge] = useState(0);
  const [deliverycountry, setDeliveryCountry] = useState('');

  const [newcountry, setNewCountry] = useState("");
  const [newstate, setNewState] = useState("");
  const [newcity, setNewCity] = useState("");

  const [area, setArea] = useState("");
  const [phone, setPhone] = useState("");
  const [productOrderId, setProductOrderId] = useState();
  const [unit_price, setUnitPrice] = useState("");
  const [tax, setTax] = useState("");
  const [remainProduct, setRemainProduct] = useState("");
  const [image, setImage] = useState("");
  const [errorList, setErrorList] = useState([]);
  // const [total, setTotal] = useState('');
  const [productDetails, setProductDetails] = useState({});

  const [loader, setLoader] = useState(false);

  const { slectedCurrency, payStatus } = useContext(LocationContext);
  const { imageCdnUrl } = useContext(serverInfo);

  // const [count, setCount] = useState(1);
  function increment() {
    setNum(function (prevCount) {
      if (prevCount < remainProduct) {
        return (prevCount += 1);
      } else {
        return (prevCount = remainProduct);
      }
    });
  }

  function decrement() {
    setNum(function (prevCount) {
      if (prevCount > 1) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 1);
      }
    });
  }

  const handleCountChange = (e) => {
    if (e.target.value > remainProduct || e.target.value < 1) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
      setNum(1);
    } else {
      setNum(Number(e.target.value));
    }
  };

  /**
   * country base price
   */
  const handelCuntrybasePrice = (fee) => {
    return (Number(fee) * Number(slectedCurrency?.currency_value)).toFixed(0);
  };

  let [num, setNum] = useState(1);

  const handelDollarTaxPrice = (taxdoller) => {
    return (Number(unit_price * num) * Number(taxdoller)) / 100;
  };

  let incNum = () => {
    if (num < 1000) {
      setNum(Number(num) + 1);
    }
  };
  let decNum = () => {
    if (num > 0) {
      setNum(num - 1);
    }
  };
  let handleChange = (e) => {
    if (e.target.value > 0) {
      setNum(e.target.value);
    }
  };

  useEffect(() => {
    axios.get(`api/user/marketplace/view-country`).then((res) => {
      setLoader(false);
      if (res.status === 200) {
        setCountry(res.data.data);
        // setNewCountry(res.data.data);
      }
    });
    axios.get(`api/user/marketplace/details/${slug}`).then((res) => {
      setLoader(false);
      if (res.status === 200) {
        setProductDetails(res.data.slugdetails);
        setUnitPrice(res.data.slugdetails.unit_price);
        // setDelivery(res.data.slugdetails.delivery_charge);
        setTax(res.data.slugdetails.tax);
        setImage(res.data.slugdetails?.image);
        setRemainProduct(res.data.slugdetails.total_items - res.data.slugdetails.total_selling);
      }
    });
    
    axios.get(`api/user/marketplacedeliverycharge`).then((res) => {
      if (res.status === 200) {
        setDeliveryChargeList(res.data.data);
        console.log("setDeliveryChargeList" ,res.data.data);
      }
    });

  }, []);


  const selectState = (e) => {
    let value = e.target.value;
    var data = value;

    axios.get(`/api/user/marketplace/state/${data}`).then((res) => {
      setLoader(false);
      if (res.status === 200) {
        setState(res.data.state);
      }
      // setLoading(false);
    });

    setNewCountry(data);
  };

  const selectCity = (e) => {
    let value = e.target.value;
    var data = value;

    axios.get(`/api/user/marketplace/city/${data}`).then((res) => {
      setLoader(false);
      if (res.status === 200) {
        setCity(res.data.city);
      }
      // setLoading(false);
    });

    setNewState(data);
  };
  const selectData = (e) => {
    let value = e.target.value;
    var data = value;
    setNewCity(data);
  };

  const selectDelivery =(e) =>{
    let data = deliverychargelist.find((item) => item.id == e.target.value);
    setDeliveryChargeId(data.id);
    setDeliveryCharge(data.courier_charge);
    setDeliveryCountry(data.courier_company);
    
    // Auto-select country based on delivery country_id
    if (data.country_id) {
      setNewCountry(data.country_id);
      
      // Fetch states based on delivery country_id
      axios.get(`/api/user/marketplace/state/${data.country_id}`).then((res) => {
        setLoader(false);
        if (res.status === 200) {
          setState(res.data.state);
          
          // Set default state (first state)
          if (res.data.state && res.data.state.length > 0) {
            const defaultState = res.data.state[0];
            setNewState(defaultState.id);
            
            // Fetch cities for default state
            axios.get(`/api/user/marketplace/city/${defaultState.id}`).then((cityRes) => {
              if (cityRes.status === 200) {
                setCity(cityRes.data.city);
                
                // Set default city (first city)
                if (cityRes.data.city && cityRes.data.city.length > 0) {
                  setNewCity(cityRes.data.city[0].id);
                }
              }
            });
          }
        }
      });
    }
  }

  const createMarketplaceOrder = async (e) => {
    e.preventDefault();
    setLoader(true);
    const formData = new FormData();

    formData.append("country_id", newcountry);
    formData.append("state_id", newstate);
    formData.append("city_id", newcity);
    formData.append("delivery_charge_id", deliverychargeid);
    formData.append("area", area);
    formData.append("phone", phone);
    formData.append("items", num);
    formData.append("unit_price", unit_price);
    formData.append("tax", tax);
    formData.append("marketplace_slug", slug);
    setModalShow(true);
    axios.post(`/api/user/marketplace/order/store`, formData).then((res) => {
      setLoader(false);
      if (res.data.status === 200) {
        setProductOrderId(res?.data?.productOrderId);
        setModalShow(true);
      } else if (res.data.status === 218) {
        swal("Error", res.data.message, "error");
      } else {
        setErrorList(res.data.errors);
      }
    });
  };
  return (
    <>
      <Navigation />
      <div className="container mt-3 card-bg1 rounded-3">
        <form className="row" onSubmit={createMarketplaceOrder}>
          <div className="col-12 my-3">
            <div className="p-3 card w-100 head-line text-center Shipping ">
              <i className="fa-solid fa-truck-fast shippingTruck   text-warning">
                &nbsp;<span className="text-light">Shipping</span>
              </i>{" "}
            </div>
          </div>

          <div className="row col-md-7 mb-3 d-flex justify-content-between ">
            <div className="card card-bg1 ">
              <div className="row py-3 px-2">
                <div className="col-md-6 mb-3">
                  <h6 className="text-warning fw-bold">Select Delivery Country</h6>
                  <select
                    id="delivery_charge_id"
                    name="delivery_charge_id"
                    onChange={selectDelivery}
                    className="bg-Shipping form-control "
                  >
                    <option value=""> --Choose Delivery Country--</option>
                    {deliverychargelist.map((charge, index) => (
                      <option className="text-whaite" value={charge.id}>
                        {charge.country}
                      </option>
                    ))}
                  </select>

                  <small className="text-danger">{errorList.delivery_charge_id}</small>
                </div>
                <div className="col-md-6 mb-3" style={{display: 'none'}}>
                  <h6 className="text-warning fw-bold">Country</h6>
                  <select
                    id="country_id"
                    name="country_id"
                    onChange={selectState}
                    className="bg-Shipping form-control "
                    value={newcountry}
                    disabled={deliverychargeid !== ''}
                  >
                    <option value=""> --Choose Country--</option>
                    {country.map((user, index) => (
                      <option className="text-whaite" value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>

                  <small className="text-danger">{errorList.country_id}</small>
                </div>

                <div className="col-md-6 mb-3">
                  <h6 className="text-warning fw-bold">State</h6>
                  <select
                    id="state_id"
                    name="state_id"
                    onChange={selectCity}
                    className="bg-Shipping form-control "
                  >
                    <option value=""> --Select State--</option>
                    {state.map((user, index) => (
                      <option className="text-whaite" value={user.id}>
                        {user.name}
                      </option>
                    ))}
                  </select>
                  <small className="text-danger">{errorList.state_id}</small>
                </div>

                <div className="col-md-6 mb-3">
                  <h6 className="text-warning fw-bold">City</h6>
                  <select
                    id="country_id"
                    name="country_id"
                    onChange={selectData}
                    className="bg-Shipping form-control "
                  >
                    <option>--Select City--</option>
                    {city.map((city, index) => (
                      <option className="text-whaite" value={city.id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                  <small className="text-danger">{errorList.city_id}</small>
                </div>

                <div className="col-md-6 mb-3">
                  <h6 className="text-warning fw-bold">Area</h6>
                  <input
                    type="text"
                    onChange={(event) => {
                      setArea(event.target.value);
                    }}
                    className="bg-Shipping form-control"
                    placeholder="Enter Area"
                  />
                  <small className="text-danger">{errorList.area}</small>
                </div>

                <div className="col-md-6 mb-3">
                  <h6 className="text-warning fw-bold">Phone</h6>
                  <input
                    type="text"
                    onChange={(event) => {
                      setPhone(event.target.value);
                    }}
                    className="bg-Shipping form-control"
                  />
                  <small className="text-danger">{errorList.phone}</small>
                </div>

                

              </div>
            </div>
          </div>
          <div className="col-md-5 mb-3">
            <div className="card bg-dark p-2 ">
              <iframe
                className="MapTFP"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.6301158824376!2d90.4066268144939!3d23.79618239294373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c70929b9639b%3A0xcb35089535094e43!2sTFP%20Solutions%20Limited!5e0!3m2!1sen!2sbd!4v1644484537435!5m2!1sen!2sbd"
              />
            </div>
          </div>
          <br />
          <div className="col-md-12 row mt-5" justify-content-between>
            <div className="col-md-5 mb-3">
              <div className="card bg-warning p-2">
                <img src={imageCdnUrl + image} alt="" />
              </div>
            </div>

            <div className="col-md-7 mb-3">
              <div className="row card-bg1 rounded-3 text-light p-3 justify-content-between align-items-center">
                <div className="col-3  mb-3">
                  <span className="text-warning fw-bold">Quantity</span>
                </div>
                <div className="col-4 justify-content-center  mb-3 ">
                  <span className="d-flex col-12 justify-content-center align-items-center ">
                    <span
                      className="btn  DecrementShip fw-bold text-light "
                      onClick={decrement}
                    >
                      -
                    </span>{" "}
                    {/* <input
                      value={num}
                      onChange={(e) => handleCountChange(e)}
                      className="form-control mx-2"
                    /> */}
                    <span className="mx-2">{num}</span>
                    {" "}
                    <span
                      className="btn IncrementShip fw-bold text-light"
                      onClick={increment}
                    >
                      +
                    </span>
                  </span>
                </div>
                <div className="col-5 mb-3 d-flex justify-content-end">
                  <span className=" text-end">
                    {handelCuntrybasePrice(unit_price * num) +
                      " " +
                      slectedCurrency?.symbol}
                  </span>
                </div>

                <div className="col-3  mb-3">
                  <span className="text-warning fw-bold">Delivery <br/> (Company Name : {deliverycountry})</span>
                </div>
                <div className="col-4 justify-content-center  mb-3 "></div>
                <div className="col-5 mb-3 d-flex justify-content-end">
                  <span className=" text-end">
                    {handelCuntrybasePrice(deliverycharge) +
                      " " +
                      slectedCurrency?.symbol}
                  </span>
                </div>

                <div className="col-3  mb-3">
                  <span className="text-warning fw-bold">Tax</span>
                </div>
                <div className="col-4 justify-content-center  mb-3 "></div>
                <div className="col-5 mb-3 d-flex justify-content-end">
                  <span className=" text-end">
                    {handelCuntrybasePrice(handelDollarTaxPrice(tax)) +
                      " " +
                      slectedCurrency?.symbol}
                  </span>
                </div>

                <div className="col-3  mb-3">
                  <span className="text-warning fw-bold">Total</span>
                </div>
                <div className="col-4 justify-content-center  mb-3 "></div>
                <div className="col-5 mb-3 d-flex justify-content-end">
                  <span className=" text-end">
                    {(
                      Number(handelCuntrybasePrice(unit_price * num)) +
                      Number(handelCuntrybasePrice(deliverycharge)) +
                      Number(handelCuntrybasePrice(handelDollarTaxPrice(tax)))
                    ).toFixed(0)}
                    {" " + slectedCurrency?.symbol}
                  </span>
                </div>
                <div className="col-12 my-3 d-flex justify-content-center">
                  {
                    remainProduct == 0 ? 'Remaining Product 0' : deliverychargeid != '' && newcountry != '' && newstate != '' && newcity != '' && area != '' && phone != ''?
                  payStatus && (
                    <button type="submit" className="btn MakePaBtn fw-bold">
                      {loader ? (
                        <>
                          <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                        </>
                      ) : (
                        <></>
                      )}
                      Order Place
                    </button>
                  ):
                  <button className="btn MakePaBtn fw-bold" disabled>
                    Please input your address before payment
                </button>}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <MyVerticallyCenteredModal
        productDetails={productDetails}
        fee={(
          Number(handelCuntrybasePrice(unit_price * num)) +
          Number(handelCuntrybasePrice(deliverycharge)) +
          Number(handelCuntrybasePrice(handelDollarTaxPrice(tax)))
        ).toFixed(0)}
        baseFee={unit_price * num + deliverycharge + tax}
        redirectTo="activities"
        event_type="marketplace"
        event_id={productOrderId}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Shipping;
